export const environment = {
  baseUrl: 'https://home.imperialcg.com/',
  production: false
};
